<template>
  <div>
    <chart-filter :chart-id="filterForm.chart_id" @change="onChange" />
    <br />
    <ai-ticket-info :filter-form="filterForm" height="360px" />
    <br />
    <ai-quality :filter-form="filterForm" height="360px" />
    <br />
    <!-- <task-point-rank :filter-form="filterForm" height="360px" />

      <br />
      <task-point-average :filter-form="filterForm" height="360px" />

      <br />
      <task-take-time-distribution :filter-form="filterForm" height="360px" />
      <br />
      <TaskPointOverTime :filter-form="filterForm" />
      <br />
      <task-created-deleted-trend :filter-form="filterForm" height="360px" />
      <br /> -->
    <!-- <TaskDely :filter-form="filterForm" height="360px" width="100%" /> -->
  </div>
</template>
<script>
import ChartFilter from '@/pages/artanis/components/ChartFilter';
import AiTicketInfo from '@/pages/artanis/components/aiTicketInfo';
import AiQuality from '@/pages/artanis/components/aiQuality';
import TaskPointAverage from '@/pages/data/task/components/TaskPointAverage';
import TaskDeliveryAloneRate from '@/pages/data/task/components/TaskDeliveryAloneRate';
import TaskPointOverTime from '@/pages/data/task/components/TaskPointOverTime';
import TaskCreatedDeletedTrend from '@/pages/data/task/components/TaskCreatedDeletedTrend';
import TaskTakeTimeDistribution from '@/pages/data/task/components/TaskTakeTimeDistribution';
// import TaskDely from '@/pages/data/task/components/TaskDely';

export default {
  components: { ChartFilter, AiTicketInfo, AiQuality },

  data() {
    return {
      filterForm: {
        begin_date: null,
        end_date: null,
        last_begin_date: null,
        last_online_date: null,
        chart_id: parseInt(this.$route.query.chartId) || null
      }
    };
  },
  methods: {
    onChange(checkedDate, lastCheckedDate, checkedTeams) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD'),
        last_begin_date: lastCheckedDate[0],
        last_end_date: lastCheckedDate[1],
        teams: checkedTeams
      };
    }
  }
};
</script>
